<template>
    <div class="liquor">
        <subsidy-note :note="subsidyNote"/>
        <s-header title="任務確認" left-btn="清除" @onLeftBtn="showClearCart" :back-route-location="backRouteLocation"/>
        <div class="product-title">
            <div>您的鑑賞內容</div>
            <router-link tag="div" class="add" :to="{ name: 'liquorShop' }" :class="{red: addErr}">
                {{ addErr ? '請選擇商品已順利下單' : '加點商品' }}
                <img src="@/assets/img/next-green.svg">
            </router-link>
        </div>
        <liquor-item :location="location" @openProduct="openProduct"/>
        <div class="divider"></div>
        <div class="detail">
            <div class="item" v-show="user.phone">
                <div class="title">委託人</div>
                <div class="principal">
                    {{ user.name + ' ' + user.phone }}
                </div>
            </div>
            <div class="item">
                <div class="title">送達地點</div>
                <router-link :to="{ name: 'task', params: { type: 'last', title: '送達地點' } }">
                    <div class="address placeholder" v-if="!cartLastLocation.road" :class="{red: err}">
                        {{ err ? '請輸入地址已順利下單' : '請輸入送達地點' }}
                    </div>
                    <div class="address content" v-else>
                        <div class="road">{{ cartLastLocation.city + cartLastLocation.district + cartLastLocation.road }}</div>
                        <div class="info">{{ (cartLastLocation.alias || '') + ' ' + (cartLastLocation.additional || '') }}</div>
                        <div class="info">{{ (cartLastLocation.name || '') + ' ' + (cartLastLocation.phone || '') }}</div>
                        <pre class="note" v-show="cartLastLocation.note">{{ cartLastLocation.note }}</pre>
                    </div>
                </router-link>
            </div>
            <div class="item">
                <div class="title">任務開始時間</div>
                <div class="time">
                    <date-time-select v-model="reservedAt" :is-align-left="true" :font-size="'16px'"/>
                </div>
            </div>
            <div class="item">
                <div class="title">優惠折扣</div>
                <div v-show="isLogin" class="coupon" @click="showCoupon = true" :class="{placeholder: ! cartCoupon}">{{ cartCoupon ? '折扣 $' + cartCoupon.value : '要用優惠碼嗎？' }}</div>
                <div v-show="!isLogin" class="coupon placeholder" @click="goToLogin">請先登入使用優惠代碼</div>
            </div>
            <div class="item">
                <div class="title">付款方式</div>
                <div class="pay" @click="showSelectPayment = true">
                    <div class="left">
                        <div class="type" v-if="payment ==='cash'">
                            現金付款 <img src="@/assets/img/credit/cash.png">
                        </div>
                        <div class="type" v-else-if="payment !== 'cash' && payment === 'credit'">
                            線上付款
                            <span>(多退少補)</span>
                        </div>
                        <div class="type" v-else>
                            <img v-if="agreement.type === 'jcb'" src="@/assets/img/credit/jcb.png">
                            <img v-else-if="agreement.type === 'visa'" src="@/assets/img/credit/visa.png">
                            <img v-else-if="agreement.type === 'master'" src="@/assets/img/credit/mastercard.png">
                            <img v-else src="@/assets/img/credit/card.png">
                            {{ agreement.card_suffix }}
                            <span>(多退少補)</span>
                        </div>
                    </div>
                    <div class="right">
                        <img src="@/assets/img/next-gray.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="price" ref="price">
                <div class="item" @click="showMinutesDetail">
                    <div class="question min">
                        <img src="@/assets/img/question-green.svg">
                    </div>
                    <div class="min">約</div>
                    <div class="minute">{{ cartMinutes }}</div>
                    <div class="min">分</div>
                </div>
                <div class="item" @click="showPriceDetail">
                    <div class="question min">
                        <img src="@/assets/img/question-green.svg">
                    </div>
                    <div>$ {{ total }}</div>
                    <div class="up min">起</div>
                    <span v-if="subsidyPrice">尖峰加成</span>
                </div>
            </div>
            <div class="button" v-if="isLogin" :class="{close: !cartLastLocation.road || ! cartLocations.length}" @click="send">
                送出任務
            </div>
            <router-link tag="div" class="button close" v-else :to="{name: 'login', query: { ot: this.$route.name }}" replace>
                <div></div>
                <div>請先登入後繼續操作</div>
                <div></div>
            </router-link>
            <div @click.stop>
                <loading loader="spinner" :active="isLoading" :width="25" :height="25"/>
            </div>
        </div>
        <clear-cart-modal ref="clearCartModal"/>
        <select-payment v-if="showSelectPayment && forceNoTouch" :only-online="onlyOnline" :payment="payment" @onClose="showSelectPayment = false" @selectPayment="selectPayment"/>
        <set-mail-modal ref="setMailModal" title="任務訊息將透過信箱通知，請輸入以利寄送" @onConfirm="send"/>
        <set-coupon v-if="showCoupon" :coupon="cartCoupon" @onDone="setCoupon" @onCancel="showCoupon = false"/>
        <shop-product ref="showProduct" is-liquor="true"/>
        <minutes-detail ref="minutesDetail"/>
        <price-detail ref="priceDetail"/>
    </div>
</template>

<script>
    import Header from './components/Header';
    import ClearCartModal from "./components/modal/ClearCartModal";
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import DateTimeSelect from './components/DateTimeSelect';
    import SelectPaymentType from './components/checkout/SelectPaymentType';
    import SetMailModal from './components/modal/SetMailModal';
    import SetCoupon from './components/order/SetCoupon';
    import Swal from "sweetalert2";
    import * as apis from "../apis";
    import LiquorItem from "./components/task/LiquorItem";
    import Product from "./shop/Product";
    import MinutesDetail from "./components/order/MinutesDetail";
    import PriceDetail from "./components/order/PriceDetail";
    import SubsidyNote from "./components/SubsidyNote";

    export default {
        name: "Liquor",
        components: {
            's-header': Header,
            'clear-cart-modal': ClearCartModal,
            'date-time-select': DateTimeSelect,
            'select-payment': SelectPaymentType,
            'set-mail-modal': SetMailModal,
            'loading': Loading,
            'set-coupon': SetCoupon,
            'liquor-item': LiquorItem,
            'shop-product': Product,
            'minutes-detail': MinutesDetail,
            'price-detail': PriceDetail,
            'subsidy-note': SubsidyNote,
        },
        data() {
            return {
                payment: 'cash',
                agreement: null,
                showSelectPayment: false,
                backRouteLocation: null,
                isLoading: false,
                showCoupon: false,
                err: false,
                addErr: false,
            };
        },
        computed: {
            reservedAt: {
                get() {
                    return this.cart.reserved_at;
                },
                set(dateTime) {
                    this.setCartData({
                        value: dateTime,
                        key: 'reserved_at'
                    });
                }
            },
            total() {
                return Math.max(parseInt(this.cartPrice) + parseInt(this.cartProductPrice) + parseInt(this.cartExpectedPrice) + parseInt(this.expectedFee) - parseInt(this.discountSurplus), 0);
            },
            onlyOnline() {
                if (this.cart.no_touch || this.forceNoTouch) {
                    return true;
                }

                return false;
            },
            overTwoThousand() {
                return this.total > 2000;
            },
            overTenThousand() {
                return this.total >= 5000;
            },
            expectedFee() {
                if (this.cart.type === 'set') {
                    return 0;
                }
                const feeRate = this.type === 'pay' ? 0.05 : 0.03;
                return this.payment === 'cash' ? 0 : Math.round(((this.cartExpectedPrice || 0) + this.cartProductPrice) * feeRate);
            },
            location() {
                return this.cartLocations[0] || {id: 0};
            },
            ...mapGetters(['cart', 'subsidyPrice', 'subsidyNote', 'cartMinutes', 'cartPrice', 'addresses', 'cartLastLocation', 'agreements', 'cartExpectedPrice', 'cartProductPrice', 'cartId', 'user', 'isLogin', 'cartCoupon', 'isLogin', 'cartLocations', 'forceNoTouch', 'discountSurplus']),
        },
        methods: {
            init() {
                if (! this.addresses.length && !this.cartLastLocation.road) {
                    this.getAddresses().then(() => {
                        let address = this.addresses.find(address => address.is_default);
                        if (address) {
                            this.putCartLastLocation(address);
                        }
                    })
                }

                if (this.payment === 'cash' && this.forceNoTouch){
                    this.payment = 'credit';
                }
            },
            openProduct(data) {
                this.$refs.showProduct.update(data.key, data.product, data.index);
            },
            goToLogin() {
                this.$router.replace({
                    name: 'login',
                    query: {
                        ot: this.$route.name
                    }
                });
            },
            setCoupon(coupon) {
                this.showCoupon = false;

                this.setCartCoupon(coupon);
            },
            showClearCart() {
                this.$refs.clearCartModal.show();
            },
            selectPayment(payment) {
                this.payment = payment;
                if (payment !== 'cash' && payment !== 'credit') {
                    this.agreement = this.agreements.find(a => parseInt(a.id) === parseInt(payment));
                }
            },
            send() {
                this.err = false;
                this.addErr = false;

                if (!this.cartLastLocation.road) {
                    this.err = true;
                    return ;
                }
                if (!this.cartLocations.length) {
                    this.addErr = true;
                    return ;
                }

                if (! this.user.email) {
                    this.isLoading = false;
                    this.$refs.setMailModal.show(this.user.email);
                    return ;
                }

                this.isLoading = true;

                if (this.cartId) {
                    this.goToPayment();
                    return;
                }

                this.sendCart().then(() => {
                    this.goToPayment();
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    })
                });
            },
            goToPayment() {
                this.isLoading = true;
                let payload = this.getPayload();

                apis.pay(payload).then(res => {
                    if (res.data.pay_url) {
                        window.location.replace(res.data.pay_url);
                    } else {
                        let orderId = this.cartId;
                        this.clearCart(this.$route.name);
                        this.$router.replace({
                            name: 'timeline',
                            params: {
                                id: orderId
                            },
                            query: {
                                new_order: 1,
                            }
                        });
                    }
                    this.isLoading = false;
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });
            },
            getPayload() {
                let payload = {
                    id: this.cartId,
                    data: {
                        type: this.payment,
                        return_url: location.pathname,
                    }
                };

                if (this.payment !== 'credit' && this.payment !== 'cash') {
                    payload.data.type = 'agreement';
                    payload.data.agreement_id = this.payment;
                }

                return payload;
            },
            showPriceDetail() {
                this.$refs.priceDetail.show(this.payment);
            },
            showMinutesDetail() {
                this.$refs.minutesDetail.show();
            },
            ...mapActions(['initCart', 'getCoupons', 'getAgreements', 'getAddresses', 'setCartData', 'putCartLastLocation', 'sendCart', 'clearCart', 'setCartCoupon'])
        },
        created() {
            if (this.$route.query.status) {
                window.history.pushState({target: 'home'}, '跑跑腿', '/app');
                this.backRouteLocation = {
                    name: 'home',
                }
            }

            if (this.$route.query.error) {
                Swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: this.$route.query.error,
                })
            }

            this.initCart(this.$route.name).then((data) => {
                if (data && data.id > 0 && data.status !== 'preparing') {
                    return this.$router.replace({
                        name: 'timeline',
                        params: {
                            id: data.id,
                        },
                    })
                }

                this.init();
            });

            if (this.isLogin) {
                this.getCoupons();
                this.getAgreements();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .liquor {
        min-height: 100%;
        flex: 1;
        position: relative;
        width: inherit;

        .product-title {
            text-align: left;
            color: #000000;
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 25px;
            margin: 0 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .add {
                display: flex;
                align-items: center;
                color: #339933;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 22px;
                cursor: pointer;
                user-select: none;

                &.red {
                    color: #ff7373;
                }
            }
        }

        .divider {
            width: 100%;
            height: 5px;
            background-color: #eee;
        }

        .detail {
            margin: 15px;
            text-align: left;

            .item {
                padding: 10px 15px;

                a {
                    text-decoration: none;
                }

                .title {
                    color: #9b9b9b;
                    font-size: 14px;
                    margin-bottom: 5px;
                }

                .time {
                    color: #339933;
                    font-size: 16px;
                    font-weight: 500;
                }

                .coupon {
                    color: #339933;
                    font-size: 16px;
                    font-weight: 500;

                    &.placeholder {
                        color: #9b9b9b;
                        font-weight: normal;
                    }
                }

                .principal {
                    color: #339933;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;
                }

                .address {
                    font-size: 16px;
                    cursor: pointer;

                    &.placeholder {
                        color: #9b9b9b;

                        &.red {
                            color: #FF7373;
                        }
                    }

                    &.content {
                        pre {
                            white-space: pre-line;
                            word-break: break-all;
                        }

                        .road {
                            margin-top: 5px;
                            color: #339933;
                            font-size: 16px;
                            font-weight: 500;
                            letter-spacing: 0;
                            line-height: 22px;
                        }

                        .info {
                            margin-top: 5px;
                            color: #4A4A4A;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                        }

                        .note {
                            margin-top: 5px;
                            font-size: 13px;
                            color: #9B9B9B;
                        }
                    }
                }

                .pay {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 13px;
                    cursor: pointer;
                    user-select: none;

                    .right {
                        display: flex;
                        align-items: center;
                        color: #9B9B9B;
                        cursor: pointer;

                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }

                    .type {
                        margin-top: 5px;
                        color: #339933;
                        font-size: 14px;
                        font-weight: 500;
                        letter-spacing: 0;
                        line-height: 22px;
                        display: flex;
                        align-items: center;

                        span {
                            color: #9B9B9B;
                        }

                        img {
                            margin-left: 5px;
                            width: 26px;
                        }
                    }
                }
            }
        }

        .tip {
            color: #339933;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            user-select: none;
            margin-bottom: 75px;
        }

        .footer {
            position: absolute;
            bottom: 0;
            width: inherit;

            .price {
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: rgba(51,153,51,1);
                font-size: 18px;
                line-height: 21px;
                background-color: white;
                transition: all .5s ease;
                width: 100%;
                padding: 0 25px;
                box-sizing: border-box;

                .item {
                    display: flex;
                    align-items: center;
                    position: relative;

                    .minute {
                        margin: 0 5px;
                    }

                    .min {
                        font-size: 12px;
                        line-height: 17px;
                    }

                    span {
                        background-color: red;
                        font-size: 13px;
                        color: #fff;
                        padding: 2px 5px;
                        border-radius: 5px;
                        font-weight: 600;
                        position: absolute;
                        top: -25px;
                        right: 0;
                    }
                }

                &.bottom {
                    position: fixed;
                    bottom: 0;
                    width: 100%;
                    max-width: 500px;
                    box-shadow: 0 -1px 1px 0 rgba(51,153,51,0.35);
                }

                .question {
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                }

                .up {
                    font-size: 12px;
                    line-height: 17px;
                    margin-left: 5px;
                }
            }

            .button {
                border-radius: 35px;
                background-color: #339933;
                color: rgba(255,255,255,1);
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                padding: 13px 25px;
                margin: 0 15px 10px 15px;
                cursor: pointer;
                display: flex;
                justify-content: center;
                position: relative;
                user-select: none;

                &.close {
                    background-color: #9b9b9b;
                    color: #fff;
                }
            }
        }
    }
</style>